import { render, staticRenderFns } from "./MarketsBox.vue?vue&type=template&id=ab5ef9ae&scoped=true&"
import script from "./MarketsBox.vue?vue&type=script&lang=js&"
export * from "./MarketsBox.vue?vue&type=script&lang=js&"
import style0 from "./MarketsBox.vue?vue&type=style&index=0&id=ab5ef9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5ef9ae",
  null
  
)

export default component.exports